export default __webpack_public_path__ + "static/media/mi.d5ee88e5.jpg";